export default "__VITE_ASSET__CEfoUukO__"